import {TrDialog} from "../../Models/tr-dialog";
import {DeleteDialog} from "../../Models/delete-dialog";

const DeleteDialogView = require('./delete-dialog.html');

interface IScope extends ng.IScope {
  resolve: (val: boolean) => void;
  factory: () => Promise<any>;
  dialog: TrDialog;
  cancel: () => void;
  confirm: () => void;
  deleting: boolean;
}

export const DeleteDialogDirective = [
  () => {
    return {
      restrict: 'E',
      scope: {instance: '='},
      templateUrl: DeleteDialogView,
      link: (scope: IScope, element, attrs) => {
        scope.dialog = new TrDialog();

        scope.$watch('instance', (value: DeleteDialog) => {
          value.open = (factory: () => Promise<any>) => {
            return new Promise<boolean>(resolve => {
              scope.factory = factory;
              scope.dialog.open();
              scope.resolve = resolve;
            });
          };
        });

        scope.cancel = () => {
          scope.dialog.close();
          scope.resolve(false);
        };

        scope.confirm = () => {
          scope.deleting = true;
          scope.factory().then(() => {
            scope.resolve(true);
            scope.dialog.close();
          }).catch(err => {
            //TODO
          });
        };
      },
    }
  }
];